export default __webpack_public_path__ + "static/media/05_kazatelna-min.3d78fce3.jpg";